//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vModal from '@/core/vModal'
import { mapGetters } from 'vuex'
export default {
  name: 'RankModal',
  extends: vModal,
  data () {
    return {
      columns: [ // 欄位宣告
        { name: 'PLU_CODE', label: '編號', field: 'PLU_CODE' },
        { name: 'PC_NAME', label: '品名', field: 'PC_NAME' },
        { name: 'CO_PRICE', label: '售價', field: 'CO_PRICE' },
        { name: 'S_PRICE', label: '特賣價', field: 'S_PRICE' },
        { name: '',
          label: '特賣期間',
          field: row => `${row.S_DATE}-${row.E_DATE}`
        }
      ],
      items: []
    }
  },
  computed: {
    ...mapGetters([
      'theme'
    ])
  },
  created () {
  },
  mounted () {
  },
  methods: {
    dataReady () {
      this.items = this.modalData
    }
  }
}
